var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.input",
  title: "Control Preview: Input",
  description: "Read-only preview renderer for ua.input values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Value to preview." },
    "type": { title: "Type", type: "string", description: "Input type from the control." },
    "controlType": { title: "Control Type", type: "string", description: "Optional control type override." }
  }
});

var helper = require("./helpers/control.preview.js");

function readType(options) {
  var t = options.controlType || options.type || "text";
  return (t || "text").toString().toLowerCase().trim();
}

exports.render = async function(options) {
  var value = options.value;
  var fieldType = readType(options);

  if (helper.isEmpty(value)) {
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    });
  }

  var text = helper.valueToText(value);

  if (fieldType === "password") {
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-text ua-control-preview-masked",
      i: helper.maskText(text)
    });
  }

  if (fieldType === "email") {
    return helper.renderDoc({
      n: "a",
      c: "ua-control-preview-link",
      href: "mailto:" + text,
      i: text
    });
  }

  if (fieldType === "url") {
    var href = text;
    if (!/^https?:\/\//i.test(href)) {
      href = "https://" + href;
    }
    return helper.renderDoc({
      n: "a",
      c: "ua-control-preview-link",
      href: href,
      target: "_blank",
      rel: "noopener noreferrer",
      i: text
    });
  }

  if (fieldType === "tel") {
    return helper.renderDoc({
      n: "a",
      c: "ua-control-preview-link",
      href: "tel:" + text.replace(/\s+/g, ""),
      i: helper.normalizePhone(text)
    });
  }

  return helper.renderDoc({
    n: "span",
    c: "ua-control-preview-text",
    i: text
  });
};
